<template>
    <v-container>
        <div>
            <div style="background-color: rgb(230, 233, 242);">
                <v-img :src="require('../assets/rcp4.png')" max-width="100%" contain>
                    <v-row>
                        <v-col cols="12" md="6" lg="6">
                            <p style="font-size: 2rem; color: rgb(0, 30, 67);padding-left: 20px; margin-top: 20px;">
                                <b>UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC)</b>
                            </p>                            
                        </v-col>
                    </v-row> 
                </v-img>
            </div>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-card-text>
                <div>
            <h2>Participating UN entities</h2>
                    <p>
                        The UN iLabCC stands as a pivotal initiative developed under the umbrella of the <a href="https://www.rcplac.org/" target="_blank">RCP LAC</a> 
                        <a href="https://www.rcplac.org/en/ibcs-and-working-groups/ibc-on-governance-for-peace-justice-and-strong-institutions" target="_blank">
                        Issue-based Coalition on Governance for Peace, Justice and Strong Institutions</a> with the technical lead of 
                        <a href="https://www.unodc.org/" target="_blank">UNODC</a>. This innovative project is a collective effort, embodying the collaborative 
                        spirit of the United Nations and aligning with the overarching goals of the RCP LAC.<br><br>

                        Currently, the project involves the active participation of <a href="https://www.unodc.org/" target="_blank">UNODC</a> (lead), 
                        <a href="https://www.un.org/securitycouncil/ctc/" target="_blank">CTED</a>, 
                        <a href="https://dppa.un.org/en" target="_blank">DPPA</a>, 
                        <a href="https://www.ilo.org/global/lang--en/index.htm" target="_blank">ILO</a>, 
                        <a href="https://www.ohchr.org/en/ohchr_homepage" target="_blank">OHCHR</a>, 
                        <a href="https://www.undp.org/" target="_blank">UNDP</a>, 
                        <a href="https://www.unesco.org/en" target="_blank">UNESCO</a>, 
                        <a href="https://www.unfpa.org/" target="_blank">UNFPA</a>, 
                        <a href="https://www.unrefugees.org/" target="_blank">UNHCR</a>, 
                        <a href="https://www.unicef.org/" target="_blank">UNICEF</a>, 
                        <a href="https://www.unwomen.org/en" target="_blank">UNOPS</a>, 
                        <a href="https://www.unodc.org/" target="_blank">UN-Women</a>. 
                        It is hoped that other UN entities will soon join and contribute to this joint project.<br><br>

                        As a flagship initiative of the RCP LAC, the UN iLabCC embodies the collective effort to address some of the most pressing challenges in the region, 
                        marking a significant step forward in the journey towards peace, justice, and strong institutional foundations.
                    </p>
                    <!--
                    <p>
                        The following UN agencies, programmes and funds are participating in this project: DPPA, ILO, OHCHR, UNDP, UNESCO, UNFPA, UNHCR, UNODC, UNOPS, UN-Women. 
                        (Other UN entities will be added, upon participation) <br>
                    </p>
                    <br>
                    <v-row>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.unodc.org/unodc/es/index.html" target="_blank">
                                <v-img class="align-end text-white" contain height="50%" :src="require('../assets/about3.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://dppa.un.org/en" target="_blank">
                                <v-img class="align-end text-white" contain height="50%" :src="require('../assets/about11.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.ilo.org/global/lang--en/index.htm" target="_blank">
                                <v-img class="align-end text-white" contain height="50%" :src="require('../assets/about5.jpg')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">                    
                            <a href="https://www.ohchr.org/SP/Pages/Home.aspx" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about1.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.acnur.org/" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about2.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.unesco.org/en" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about6.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.unfpa.org/" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about7.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.unops.org/" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about8.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.unwomen.org/en" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about9.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.unicef.org/" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about10.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.wfp.org/" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about12.png')"></v-img>
                            </a>
                        </v-col>
                        <v-col cols="12" md="6" lg="2">
                            <a href="https://www.un.org/securitycouncil/ctc/" target="_blank">
                                <v-img class="align-end text-white" contain height="70%" :src="require('../assets/about13.png')"></v-img>
                            </a>
                        </v-col>
                    </v-row> 
                    -->
                </div>
            </v-card-text>
            <v-spacer></v-spacer>
        </div>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: [],
                chip: [],
            },
            showPdf: false,
        };  
    },
    methods: {        
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        openPdf() {
            this.showPdf = true;
        },
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1 {
        font-family: 'Heebo', sans-serif;
        font-size: 14px;        
        line-height: 1.6em;
    }
</style>                    